module.exports = __webpack_public_path__ + "static/media/ico-bigstar.8d728fec.svg";